import { configureStore } from '@reduxjs/toolkit'
import userSlice from './slice/UserSlice'
import alertSlice from './slice/AlertSlice'
import selectedDateSlice from './slice/SelectedDateSlice'
import ProjectsSlice from './slice/ProjectsSlice'
import loadingDateSlice from './slice/LoadingDateSlice'
import themeSlice from './slice/ThemeSlice'
import JournalSlice from './slice/JournalSlice'
import OrderSlice from './slice/OrderSlice'
import ReportSlice from './slice/ReportSlice'
import OperationalPeriodsSlice from './slice/OperationalPeriodsSlice'
import TemplateSlice from './slice/TemplateSlice'
import BaselineSlice from './slice/BaselineSlice'
import CalendarDates from './slice/CalendarDatesSlice'
import weekStartSlice from './slice/WeekStartSlice'
import { injectedEndpoints } from '@/api/InjectedEndpoints'

export const store = configureStore({
    reducer: {
        user: userSlice,
        alert: alertSlice,
        selectedDate: selectedDateSlice,
        projects: ProjectsSlice,
        loadingDate: loadingDateSlice,
        theme: themeSlice,
        journal: JournalSlice,
        orders: OrderSlice,
        report: ReportSlice,
        operationalPeriods: OperationalPeriodsSlice,
        template: TemplateSlice,
        baseline: BaselineSlice,
        calendarDates: CalendarDates,
        weekStart: weekStartSlice,
        [injectedEndpoints.reducerPath]: injectedEndpoints.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(injectedEndpoints.middleware),
})
